import {create} from 'zustand';

export const useRegistrationStore = create(set => ({
  ownerName: '',
  email: '',
  phone: '',
  countryCode: '+91',
  countryIso: 'IN',
  otp: '',

  setField: (field, value) => set({[field]: value}),

  reset: () =>
    set({
      ownerName: '',
      email: '',
      phone: '',
      countryCode: '+91',
      countryIso: 'IN',
      otp: '',
    }),
}));
